module.exports = __webpack_public_path__ + "static/img/slide-5.6647bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-5.jpg
// module id = BisY
// module chunks = 1